'use strict';

var App = require('app');
var AppState = require('app_state');
var StatsDeviceSelectView = require('components/devices/views/tools/stats/stats_device_select_view');
var Devices = require('models/devices');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

var StatsDialogDeviceListView = OOP.extend(
    StatsDeviceSelectView,
    {
        initialize: function (data) {
            var tablePage = data.tablePage || {};
            this.stats = data.stats;
            this.columns = data.columns;
            this.currentPage = tablePage.currentPage || this.currentPage;
            this.currentSortCol = tablePage.currentSortCol || this.currentSortCol;
            this.currentSortDesc = tablePage.currentSortDesc || this.currentSortDesc;
            this.itemCount = data.itemCount || this.itemCount;
            this.tablePage = data.tablePage;

            var tableConfig = this.getTableConfiguration();
            tableConfig.selectionCtx = data.selectionCtx;
            this.base.initialize(tableConfig);
            this.listResult = data.listResult;
            this.controller = data.controller;
            this.itemsPerPage = tablePage.itemsPerPage || this.itemsPerPage;
        },

        getTablePage: function () {
            return {
                collection: this.collection,
                itemCount: this.itemCount,
                currentPage: this.currentPage,
                itemsPerPage: this.itemsPerPage,
                currentSortCol: this.currentSortCol,
                currentSortDesc: this.currentSortDesc,
            };
        },

        getTableConfiguration: function () {
            var self = this;
            var tablePage = this.tablePage;
            var tableConfig = {
                isInModal: true,
                title: '',
                itemsPerPage: tablePage.itemsPerPage || AppState.getItemsPerPage() || 50,
                itemCount: this.itemCount,
                getSortColumn: this.getSortColumnFunc(),
                columns: _.flatten([
                    [
                        { id: '#_name', name: 'Name', alwaysVisible: true }, // i18n.TR('Name')
                    ],
                    Misc.selectWhere(this.columns, undefined, function (item) {
                        return {
                            id: item.id,
                            name: item.name,
                            displayMethod: 'displayValue',
                        };
                    }),
                ]),
                hasRefreshButton: false,
                hasSelectionButtons: true,
                footRows: this.buildFootRows(),
                customButtons: [],
                displayMethods: {
                    displayValue: function (value, model, attr) {
                        // is it a value with an error
                        var data = model.data;
                        var columns = AppState.uniqueColumns();
                        var result = Misc.formatDeviceAttr(model, attr, columns);
                        if (data && data[attr] && data[attr].error) {
                            var r = Misc.formatValueUnit(data[attr].oldValue, attr, columns);
                            result = Misc.warningHTML(I18N.TR('Anfrage fehlgeschlagen')) + ' ' + r.value + ' ' + r.unit;
                        }

                        return result;
                    },
                },
            };
            return tableConfig;
        },

        buildFootRows: function () {
            var self = this;
            var rows = [
                { caption: I18N.TR('Anzahl'), key: 'count' },
                { caption: I18N.TR('Durchschnitt'), key: 'avg' },
                { caption: I18N.TR('Maximum'), key: 'max' },
                { caption: I18N.TR('Minimum'), key: 'min' },
                { caption: I18N.TR('Summe'), key: 'sum' },
            ];

            return Misc.selectWhere(rows, undefined, function (rowDef) {
                var row = {
                    '#_name': rowDef.caption,
                };

                var stats = self.stats || {};
                _.each(stats.series, function (x) {
                    var category = undefined;
                    if (self.options.categories && self.options.categories.length === 1) {
                        category = self.options.categories[0];
                    }

                    var v = x.result ? x.result[rowDef.key] : undefined;
                    row[x.value] =
                        rowDef.key == 'count'
                            ? v
                            : Misc.formatValueUnitStr(v, x.value, AppState.uniqueColumns(category));
                });

                _.each(self.columns, function (x) {
                    if (!row[x.id]) row[x.id] = '--';
                });
                return row;
            });
        },
    },
    'StatsDialogDeviceListView'
);

module.exports = StatsDialogDeviceListView;
